const changeViewDropdown = {
  company: {
    body: '¿Estás seguro de que quieres cambiar de empresa?',
  },
  site: {
    body: '¿Estás seguro de que quieres cambiar de sitio?',
  },
};

export default changeViewDropdown;
